import { render, staticRenderFns } from "./fabric.vue?vue&type=template&id=3ee672ef&scoped=true"
import script from "./fabric.vue?vue&type=script&lang=js"
export * from "./fabric.vue?vue&type=script&lang=js"
import style0 from "./fabric.vue?vue&type=style&index=0&id=3ee672ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee672ef",
  null
  
)

export default component.exports